module.exports = __webpack_public_path__ + "img/bin.9e10febb.svg";